import styled from "styled-components"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { usePagePermissions } from "hooks/permissions.hooks"
import { useDefaultCurrencyIso } from "hooks/settings"
import { ExportOutlined } from "@ant-design/icons"
import { useTaskDetailsModal } from "../task-details-modal"
import { toAmountWithCurrency } from "utils/string-utils"
import { RestrictedIcon } from "components/base/restricted-icon"
import { TaskFormObject } from "@timenotes/shared/src/services/tasks/hooks/use-task-formik"
import { isTaskAboveEstimate } from "@timenotes/shared/src/services/tasks/utils/is-task-above-estimate"
import { TApiProject, TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { formatTaskDurationWithEstimate } from "@timenotes/shared/src/services/tasks/utils/format-task-duration-with-estimate"

interface Props {}

export const TaskSummary = (props: Props) => {
  const {} = props

  const formik = useFormikContext<TaskFormObject>()
  const task = formik.values
  const project = task.project as TApiProject

  const isProjectBillable = !!project.billableEnabled

  const {
    permissions,
  } = usePagePermissions()

  const canSeeBillable = !!permissions?.filterBillableTimelogs

  const {
    openTaskTimesheet,
  } = useTaskDetailsModal()

  const { defaultCurrencyIso } = useDefaultCurrencyIso()


  return (
    <>
      <SidebarButton
        icon={<ExportOutlined />}
        onClick={openTaskTimesheet}
      >
        Summary
      </SidebarButton>

      <div
        style={{
          marginTop: '8px',
          marginLeft: '8px',
        }}
      >
        <SummaryRow>
          <div>
            Time Logged
          </div>
          <div
            style={{
              color: isTaskAboveEstimate(task as TApiTaskDetails) ? 'red' : undefined
            }}
          >
            { formatTaskDurationWithEstimate(task as TApiTaskDetails)}
          </div>
        </SummaryRow>

        {canSeeBillable && (
          <>
            { isProjectBillable && (
              <SummaryRow>
                <div>
                  Billable
                  <RestrictedIcon />
                </div>
                <div>
                  { toAmountWithCurrency(task.billableAmount || null, defaultCurrencyIso) }
                </div>
              </SummaryRow>
            )}

            <SummaryRow>
              <div>
                Cost
                <RestrictedIcon />
              </div>
              <div>
                { toAmountWithCurrency(task.costAmount || null, defaultCurrencyIso) }
              </div>
            </SummaryRow>
          </>
        )}

      </div>
    </>
  )
}

const SummaryRow = styled.div`
  margin-right: 8px;
  display: flex;
  justify-content: space-between;
`